import React from 'react';
// Icons
import { FaShieldAlt } from 'react-icons/fa';
import { FaLightbulb } from 'react-icons/fa6';
import { FaInfinity } from 'react-icons/fa6';

const TableLegend = () => {
  return (
    <div className="legend-main my-2">
      <span>Legenda:</span>
      <span className="ms-3">
        <FaShieldAlt className="partner-icon partner-icon--insurance" />
        Seguros
      </span>
      <span className="ms-3">
        <FaLightbulb className="partner-icon partner-icon--energy" />
        Energia
      </span>
      <span className="ms-3">
        <FaInfinity className="partner-icon partner-icon--other" />
        Outros
      </span>
    </div>
  );
};

export default TableLegend;
